import { createMinorSuitCore } from '../internal/core-builders';

export const MINOR_WANDS_CORE = createMinorSuitCore('Bastoni');
